<template>
  <div>
    <div class="sayfahead tek">
      <h1>Lazer Fatura</h1>
      <el-button-group v-if="tableDisplay" class="YeniBtn">
        <el-button type="primary" size="small" @click="Yazdir"
                   icon="el-icon-success">Yazdır
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik" style="height: calc(100vh + 25px) !important;">
      <Yukleniyor :data="lo"></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">
          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="3">
              <el-form-item label="Durum" prop="Durum">
                <el-select v-model="Form.Durum" filterable @change="Getir">
                  <el-option
                    label="Bekleyen"
                    value="0">
                  </el-option>
                  <el-option
                    label="Fatura Kesilmiş"
                    value="1">
                  </el-option>
                  <el-option
                    label="Yoksayılmış"
                    value="2">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="14">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Yukleniyor from "../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      tableDisplay: false,
      lo: false
    }
  },
  methods: {
    Yazdir() {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_a/lazerFatura.vue